export default "__VITE_ASSET__UFtkZ6Sp__"